// @ts-nocheck
import * as React from "react";

const GridFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4l.005-.15A2 2 0 0 1 5 13Zm10 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4l.005-.15A2 2 0 0 1 15 13ZM9 3a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5l.005-.15A2 2 0 0 1 5 3Zm10 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5l.005-.15A2 2 0 0 1 15 3Z"
            />
        </svg>
    );
};

export default React.memo(GridFill);
